module.exports = __webpack_public_path__ + "static/img/8.066634a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/8.png
// module id = /GTs
// module chunks = 0